import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../api/generated';
import { IWindowComponentProps } from '../windows/WindowContext';
import LocationTree, { ILocationItem } from './LocationTree';

interface LocationSelectionFieldWindowProps {
    onSelect: (locationItem: ILocationItem) => void;
}

const LocationSelectionFieldWindow: FC<IWindowComponentProps<LocationSelectionFieldWindowProps>> = (props) => {
    const {
        componentProps: { onSelect },
        onClose
    } = props;

    const [locations, setLocations] = useState<ILocationItem[] | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const locations = await api.administration.getLocations(null);
                setLocations(locations);
            } catch (ex) {
                toast.error(ex.error[0]);
            }
        };
        fetchData();
    }, []);

    const handleSelect = (locationKey: string | undefined) => {
        if (locationKey) {
            const location = locations?.find((x) => x.id === parseInt(locationKey));
            if (location) onSelect(location);
        }
        onClose();
    };

    return locations && <LocationTree onLoadSelectedId={null} locations={locations} onSelect={handleSelect} />;
};

export default LocationSelectionFieldWindow;
